const createDateRange = (from, to, step) => {
  const unit = step.replace('week', 'isoWeek');
  const start = from.clone().startOf(unit);
  const end = to.clone().startOf(unit);
  const result = [start];
  let current = start;
  while (end.diff(current) > 0) {
    current = current.clone().add(1, step);
    result.push(current);
  }
  return result;
};

export default createDateRange;
